import React, { Component } from 'react';
import { connect } from 'react-redux'
import { filterSort } from '../../../actions'
import { getVisibleproducts } from '../../../services';

class FilterBar extends Component {

    //List Layout View
    listLayout() {
        document.querySelector(".collection-grid-view").style = "opacity:0";
        document.querySelector(".product-wrapper-grid").style = "opacity:0.2";
        document.querySelector(".product-wrapper-grid").classList.add("list-view");
        var elems = document.querySelector(".infinite-scroll-component .row").childNodes;
        [].forEach.call(elems, function (el) {
            el.className = '';
            el.classList.add('col-lg-12');
        });
        setTimeout(function () {
            document.querySelector(".product-wrapper-grid").style = "opacity: 1";
        }, 500);
    }

    //Grid Layout View
    gridLayout() {
        document.querySelector(".collection-grid-view").style = "opacity:1";
        document.querySelector(".product-wrapper-grid").classList.remove("list-view");
        var elems = document.querySelector(".infinite-scroll-component .row").childNodes;
        [].forEach.call(elems, function (el) {
            el.className = '';
            el.classList.add('col-lg-3');
        });
    }

    // Layout Column View
    LayoutView = (colSize) => {
        if (!document.querySelector(".product-wrapper-grid").classList.contains("list-view")) {
            var elems = document.querySelector(".infinite-scroll-component .row").childNodes;
            [].forEach.call(elems, function (el) {
                el.className = '';
                el.classList.add('col-lg-' + colSize);
            });
        }

        this.props.onLayoutViewClicked(colSize);
    }

    render() {
        return (
            <div className="product-filter-content" style={{ justifyContent: 'space-between' }}>
                <div className="search-count">
                    <h5>تعداد محصول: {this.props.products.length}</h5>
                </div>

                <div>

                </div>
                <div className="product-page-filter">
                    <select onChange={(e) => this.props.filterSort(e.target.value)}>
                        <option value="">ترتیب بر اساس:</option>
                        <option value="HighToLow">گرانترین</option>
                        <option value="LowToHigh">ارزان ترین</option>
                        <option value="Newest">محبوب ترین</option>
                        {/* <option value="AscOrder">Sort By Name: A To Z</option>
                        <option value="DescOrder">Sort By Name: Z To A</option> */}
                    </select>
                </div>
                {/* <div className="collection-view">
                    <ul>
                        <li><i
                            className="fa fa-th grid-layout-view" onClick={this.gridLayout}></i>
                        </li>
                        <li><i
                            className="fa fa-list-ul list-layout-view" onClick={this.listLayout}></i>
                        </li>
                    </ul>
                </div> */}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    products: getVisibleproducts(state.data, state.filters),
    filters: state.filters
})

export default connect(mapStateToProps, { filterSort })(FilterBar);